import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

import moment from 'moment-timezone';

import App from '@/app.vue';
import router from '@/router';
import {Enum} from '@/app/shared/enum/enum';
import {Option} from '@/app/shared/enum/option';
import {Message} from '@/app/shared/model/message.model';
import {Mapper} from '@/core/service/mapper.service';
import {Broadcast} from '@/core/service/broadcast.service';
import UtilService from '@/app/shared/service/util.service';
import NSpinner from '@/app/shared/components/n-spinner.vue';
import NAgreeModal from '@/app/shared/components/n-agree-modal.vue';
import NContentHeader from '@/app/shared/components/n-content-header.vue';
import airbridge from 'airbridge-web-sdk-loader';

import '@/app/shared/filter/shared.filter';
import '@/app/shared/directive/shared.directive';
import '@/assets/css/styles.css';
import '@/assets/css/custom.css';

Vue.config.devtools = process.env.NODE_ENV === Enum.CORE.ENV.LOCAL;
Vue.config.performance = process.env.NODE_ENV === Enum.CORE.ENV.LOCAL;
Vue.config.silent = process.env.NODE_ENV === Enum.CORE.ENV.PROD;
Vue.config.productionTip = false;

Vue.prototype.$enum = Enum;
Vue.prototype.$option = Option;
Vue.prototype.$message = Message;
Vue.prototype.$util = new UtilService();
Vue.prototype.$broadcast = new Broadcast();
Vue.prototype.$mapper = new Mapper();
Vue.prototype.$moment = moment;

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.component('n-spinner', NSpinner);
Vue.component('n-agree-modal', NAgreeModal);
Vue.component('n-content-header', NContentHeader);

airbridge.init({
    app: `${process.env.VUE_APP_AIR_BRIDGE_APP}`,
    webToken: `${process.env.VUE_APP_AIR_BRIDGE_WEB_TOKEN}`,
    utmParsing : true
});

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
